import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import styled from 'styled-components';
import { iconButtonClasses } from '@mui/material';

const Wrapper = styled.div`
  .dropdown-item.active, .dropdown-item:active {
    background-color: #F0F0F0;
  }
`;

export default class Dropdown extends React.Component {
	constructor(props) {
		super(props);
	}

	render(props) {
		const {
			parentFunction,
			icon = null, // classes font-awesome Ex: fa-regular fa-bars-sort
			title,
			items,
			selectedItem,
			align = 'left',
			disabled = false,
			tooltip = false,
			tooltipText = '',
			groups = false,
			displayChevron = true,
			btnClass = 'btn-gc-light-blue-dark text-gc-dark-blue font-weight-bold',
			autoTrad = true
		} = this.props;

		let finalBtnClass = btnClass+ " btn w-100 w-md-auto" + (disabled ? ' disabled' : '');

		let attr = {
			className: "dropdown"
		}

		let current_group = '';

		if (tooltip == true) {
			attr = {
				className: "dropdown js-tooltip",
				title: tooltipText,
				'data-placement': "bottom",
				'data-tooltip': "tooltip",
			}
		}

		return (
			<Wrapper
				{...attr}
			>
				<a
					className={finalBtnClass}
					href="#"
					role="button"
					data-toggle="dropdown"
				>
					{icon &&
						<span className="mr-md-2">
							<i className={icon}></i>
						</span>
					}

					<span className="d-none d-md-inline-block">
						{title}
					</span>

					{displayChevron && <span className="ml-2 ml-md-4">
						{open == true ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
					</span>}
				</a>

				<div className={"dropdown-menu text-gc-dark-blue" + (align == 'right' && " dropdown-menu-right")}>
					{items.map((e, index) => {
						let display_group = false;
						if(groups && (e.group != current_group) ) {
							
							current_group = e.group;
							display_group = true;
							
						}

						let icon = e.icon ? <i className={e.icon + ' mr-1'}></i> : null;
						let label = autoTrad ? (e.label ? e.label.trad() : e.trad()) : e.label;

						return (
							<div key={index}>
								{display_group && <span className="dropdown-header">{e.group}</span>}
								<a
									onClick={!disabled ? () => parentFunction(e) : () => false}
									key={index}
									className={"dropdown-item font-weight-normal selected " + (e.disabled ? 'disabled' : 'text-gc-dark-blue')}
									style={{ cursor: 'pointer' }}
								>
									<div>{icon} {label}</div>
									{e.descr && <div className="text-muted small">{e.descr}</div>}
								</a>
							</div>
						);
					})}
				</div>
			</Wrapper>
		);
	}
}